import api from '@pray/shared/utils/api';
import type { ObjectResponse } from '@pray/shared/utils/api/types/response';

import type { ContentCategoryAdminResponse, UpdateContentCategoryParams } from './types';

export async function updateContentCategory(contentCategoryId: string, params: UpdateContentCategoryParams) {
  const url = `/web/studio/content-categories/${contentCategoryId}`;

  const body: UpdateContentCategoryParams = {};
  if (params.name !== undefined) body.name = params.name;
  if (params.destroyed !== undefined) body.destroyed = params.destroyed;

  const response = await api.executePutRequest<ObjectResponse<ContentCategoryAdminResponse>>(url, body);

  return response.data;
}
